module.exports = __webpack_public_path__ + "img/regi_guide_4-3-2.39ec916b.png";